export const NOTIFICATION_REDUCER_KEYS = {
  REDUCER: 'notifications',
  BY_ID: 'byID',
}
